import { tranfer_bank_to_program } from "@/constants/programs";

export const getBanksByProgram = (program: string): string[] => {
  const res = [];
  for (const [key, val] of tranfer_bank_to_program.entries()) {
    if (val.includes(program)) {
      res.push(key);
    }
  }

  return res.length > 0 ? res : ["Z"];
};
